import { Component, Input } from "@angular/core";

@Component({
  selector: "vl-logo",
  standalone: true,
  imports: [],
  templateUrl: "./logo.component.svg",
  styleUrl: "./logo.component.scss",
})
export class LogoComponent {
  @Input() textColor: string = "#FFFFFF";
  @Input() uColor: string = "#05FFAD";
}
